import React from 'react';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const getOrderSummaryInfoDetailsView = props => {
  return (
    <LazyLoaderWrapper
      {...props}
      testId='order_summary_info_details_view'
      importPath='ORDER_SUMMARY_INFO_DETAILS_VIEW'
    ></LazyLoaderWrapper>
  );
};

const OrderSummaryInfoDetails = props => {
  return getOrderSummaryInfoDetailsView(props);
};

export default OrderSummaryInfoDetails;
